export function hjEvent(path: string) {
  const hj = (window as { [key: string]: any })['hj'];

  if (hj) {
    hj('stateChange', path);
  }
}
